import React, { useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { setOptionAction } from '../../../Actions/option';
import { isEmpty } from 'lodash';
import { locationOfCarpeteAction, secondCarpeteAction, sizeChangeAction } from '../../../Actions/paramsOfTextureAction';



const Tools = () => {
    const tools = useSelector(state => state.feature);
    const secondCarpet = useSelector(state => state.secondCarpet);
    const dispatch = useDispatch();


    const defaultSizes = ["2.00x3.00",  "2.50x3.50", "3.00x4.00", "1.50x2.25", "1.00x1.15", "0.50x0.80"];
    useEffect(() => {
        const size_key = Object.keys(tools.translate).filter(item => item === 'size' || item === 'سایز');
        const main_size = Object.values(tools.translate[size_key])[0]

        const carpet_sizes = {current_size: defaultSizes[0], main_size : main_size }
        dispatch(sizeChangeAction(carpet_sizes));

      },[]);

    return (
        <>
            <div className='w-100 py-2'>
                <div className='w-100 p-1'>
                    {!isEmpty(tools) ? Object.keys(tools.translate).filter(item => item === "size" || item === "سایز").map((item,index) => (
                        <div key={index}>
                            <Form.Select className='w-100 text-center px-1' onChange={(e) => {
                                
                                if (!isEmpty(e.target.options[e.target.selectedIndex].value)) {
                                    //dispatch(setOptionAction(e.target.options[e.target.selectedIndex].value));
                                    const carpet_size = e.target.options[e.target.selectedIndex].value
                                    const parts = carpet_size.split(item + ':');
                                    const main_size = parts.join('');
                                    const carpet_sizes = {current_size: Object.values(tools.translate[item])[0], main_size : main_size }
                                    dispatch(sizeChangeAction(carpet_sizes));
                                }
                            }}>
                                <option className='shadow-sm' disabled value="" variant="light">{item}</option>
                                {defaultSizes.map((ele,index) => (
                                    <option key={index} className='text-dark text-center' value={`${item}:${ele}`}>{ele}</option>
                                ))}
                    
                            </Form.Select>
                        </div>
                    )) : null}
                </div>
                <div className='w-100 scale-wrapper px-1'>
                    <Button variant='light' className='w-100 small' onClick={() => dispatch(locationOfCarpeteAction())}>مکان پیش فرض</Button>
                    <Button variant='light' className='w-100 small' onClick={() => dispatch(secondCarpeteAction())}>{secondCarpet ? "حذف فرش دوم" : "فرش دوم"}</Button>
                </div>
            </div>
        </>
    );
}


export default Tools;
